module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " \u0625\u0644\u0649 ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " \u0627\u0644\u0645\u062D\u062F\u062F");
  },
  "finishRangeSelectionPrompt": "\u0627\u0646\u0642\u0631 \u0644\u0625\u0646\u0647\u0627\u0621 \u0639\u0645\u0644\u064A\u0629 \u062A\u062D\u062F\u064A\u062F \u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
  "maximumDate": "\u0622\u062E\u0631 \u062A\u0627\u0631\u064A\u062E \u0645\u062A\u0627\u062D",
  "minimumDate": "\u0623\u0648\u0644 \u062A\u0627\u0631\u064A\u062E \u0645\u062A\u0627\u062D",
  "next": "\u0627\u0644\u062A\u0627\u0644\u064A",
  "previous": "\u0627\u0644\u0633\u0627\u0628\u0642",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u062A\u0627\u0631\u064A\u062E \u0645\u062D\u062F\u062F: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u0627\u0644\u0645\u062F\u0649 \u0627\u0644\u0632\u0645\u0646\u064A \u0627\u0644\u0645\u062D\u062F\u062F: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "\u0627\u0646\u0642\u0631 \u0644\u0628\u062F\u0621 \u0639\u0645\u0644\u064A\u0629 \u062A\u062D\u062F\u064A\u062F \u0646\u0637\u0627\u0642 \u0627\u0644\u062A\u0627\u0631\u064A\u062E",
  "todayDate": function todayDate(args) {
    return "\u0627\u0644\u064A\u0648\u0645\u060C ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "\u0627\u0644\u064A\u0648\u0645\u060C ".concat(args.date, " \u0645\u062D\u062F\u062F");
  }
};